//* HOC's
import { withLanguageContext } from 'context'

//* Components
import Text from 'components/common/Text'
import Image from 'components/common/Image'
import CustomLink from 'components/common/CustomLink'

const Hit = ({ title, featured_description, image, url, tags, selectedLang, imagePrefix }) => {
	return (
		<div className={`search-item-cont col-4 col-dxs-3 col-t-6 col-m-12`}>
			<CustomLink url={url}>
				<div className='search-item primaryColor3-bg'>
					<Image objectFit='cover' className='search-item-image' src={`${imagePrefix}${image}`} alt={title[selectedLang] || title['en']} />
					<div className='search-info-cont'>
						<Text tag='h2' text={title[selectedLang] || title['en']} className={`search-item-title font-ping-bolder h6`} />
						<Text
							tag='h3'
							text={featured_description[selectedLang] || featured_description['en']}
							className={`search-item-desc secondaryColor2 p pS`}
						/>

						<div className='search-item-tags'>
							{tags?.map((t, j) => (
								<span className='search-item-tag p pXS' key={j}>
									{`#${t[selectedLang] || t['en']} `}
								</span>
							))}
						</div>
					</div>
				</div>
			</CustomLink>
		</div>
	)
}

export default withLanguageContext(Hit, ['selectedLang'])
